import { observer } from 'mobx-react';
import React from 'react';
import { Modal, ModalContent, ModalProvider } from 'telia-front-react';
const TradeInSuccessModal = observer(({ tradeInStore: { isModalOpen, setModalOpen }, tradeInSuccessContent }) => {
    return (React.createElement(ModalProvider, { id: 'tradeIn-modal', isOpen: isModalOpen, onToggle: setModalOpen, isClosable: true },
        React.createElement(Modal, { hasContentComponent: true, size: '6-col', "aria-labelledby": "added-modal-title", initialFocusedElementId: "enter-shop-button" },
            React.createElement(ModalContent, null, tradeInSuccessContent))));
});
export default TradeInSuccessModal;
